"use client";

import { useQuery } from "@tanstack/react-query";
import { workspaceAppsApi } from "../api";
import { workspaceAppsKeys } from "../queryKeys";

export function useWorkspaceApplicationCatalogQuery(workspaceUuid: string) {
  return useQuery({
    queryKey: workspaceAppsKeys.catalog(workspaceUuid),
    queryFn: () => workspaceAppsApi.listApplicationCatalog(workspaceUuid),
    enabled: workspaceUuid !== "",
  });
}
